import {
  createOrder,
  getOrders,
  deleteOrder,
  updateOrderStatus,
} from "./asyncThunks";

export const createOrderBuilder = (builder) => {
  builder.addCase(createOrder.pending, (state) => {
    state.order.loading = true;
  });
  builder.addCase(createOrder.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.order.newOrder = data;
    state.order.loading = false;
  });
  builder.addCase(createOrder.rejected, (state, action) => {
    state.order.loading = false;
    state.order.error = action.error.message;
  });
};

export const getOrdersBuilder = (builder) => {
  builder.addCase(getOrders.pending, (state) => {
    state.orders.loading = true;
  });
  builder.addCase(getOrders.fulfilled, (state, { payload }) => {
    const {
      data,
      pagination,
      lastMonthRevenue,
      thisMonthRevenue,
      totalRevenue,
    } = payload;
    state.orders.data = data;
    state.orders.pagination = pagination;
    state.orders.lastMonthRevenue = lastMonthRevenue;
    state.orders.thisMonthRevenue = thisMonthRevenue;
    state.orders.totalRevenue = totalRevenue;
    state.orders.loading = false;
  });
  builder.addCase(getOrders.rejected, (state, action) => {
    state.orders.loading = false;
    state.orders.error = action.error.message;
  });
};

export const updateOrderStatusBuilder = (builder) => {
  builder.addCase(updateOrderStatus.pending, (state) => {
    state.orders.updateStatusLoading = true;
  });
  builder.addCase(updateOrderStatus.fulfilled, (state, { payload }) => {
    const { id, status } = payload.data;

    const index = state.orders.data.findIndex((order) => order.id === id);
    if (index !== -1) {
      state.orders.data[index].status = status;
    }

    state.orders.updateStatusLoading = false;
  });
  builder.addCase(updateOrderStatus.rejected, (state, action) => {
    state.orders.updateStatusLoading = false;
    state.orders.error = action.error.message;
  });
};

export const deleteOrderBuilder = (builder) => {
  builder.addCase(deleteOrder.pending, (state) => {
    state.orders.deleteLoading = true;
  });
  builder.addCase(deleteOrder.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.orders.data = state.orders.data.filter(
      (order) => order.id !== data.id
    );
    // Update pagination total count
    if (state.orders.pagination) {
      state.orders.pagination.totalOrders =
        state.orders.pagination.totalOrders - 1;
      state.orders.pagination.totalPages = Math.ceil(
        state.orders.pagination.totalOrders / state.orders.pagination.limit
      );
    }
    state.orders.deleteLoading = false;
  });
  builder.addCase(deleteOrder.rejected, (state, action) => {
    state.orders.deleteLoading = false;
    state.orders.error = action.error.message;
  });
};
